import React from "react";

import ModalV4 from "../../../app/ui/modal/v4/v4";
import ModalAddUserTaskUsersForm from "./add-task-users-form/add-task-users-form";
import ModalAddUserProjectUsersForm from "./add-project-users-form/add-project-users-form";
import ModalAddUserCommonUsersForm from "./add-common-users-form/add-common-users-form";
import {Access} from "../../gd/const/access"

// params
// mode = task | project | chat | common - indicated if we add user to task, project, chat or common
// multiselect = true / false
// task users

class ModalAddUser extends ModalV4 {

    constructor(props) {
        super(props);

        this.mode = props.params.mode;
        this.multiselect = props.params.multiselect;

        this.projectId = props.params.projectId;
        this.companyId = null;

        this.showDepartments    = (gd.session.departments.filterByCompany(this.companyId).length>1);
        this.accessLevels       = props.params.accessLevels


        // precalculate potential users...
        this.existingUsers = [];
        this.projectUsers = [];
        this.companyUsers = [];

        let tempProjectUsersIds = [];

        switch (this.mode) {
            case 'chat':
                if (props.params.chatUsers) this.existingUsers = props.params.chatUsers.map(cu=>cu.userId);

            case 'task': {
                this.companyId = props.params.companyId;

                if (props.params.taskUsers) this.existingUsers = props.params.taskUsers.map(tu=>{return tu.userId; });

                // get all project users
                gd.session.projectUsers.filterByProject(this.projectId).map(pu=>{tempProjectUsersIds.push(pu.user.id);});

                // get all available project users
                gd.session.projectUsers.filterByProject(this.projectId, gd.const.project.access.LIMITED).map(pu=>{
                    if (!this.existingUsers.includes(pu.user.id)) {
                        this.projectUsers.push(pu);
                    }
                });

                gd.session.companyUsers.filterByCompanyAndRoles(props.params.companyId).map(cu=>{
                    if (!this.existingUsers.includes(cu.user.id) && !tempProjectUsersIds.includes(cu.user.id)) {
                        this.companyUsers.push(cu);
                    }
                });

                // sort by name
                this.projectUsers = _.sortBy(this.projectUsers,(pu=>{return pu.user.name}));
                this.companyUsers = _.sortBy(this.companyUsers,(cu=>{return cu.user.name}));
            } break;

            case 'project': {
                this.companyId = gd.session.projects.get(this.projectId).companyId;

                this.existingUsers = gd.session.projectUsers.filterByProject(this.projectId).map(pu=>{return pu.user.id; });

                gd.session.companyUsers.filterByCompanyAndRoles(this.companyId).map(cu=>{
                    if (!this.existingUsers.includes(cu.user.id)) {
                        this.companyUsers.push(cu);
                    }
                });

                // sort by name
                this.companyUsers = _.sortBy(this.companyUsers,(cu=>{return cu.user.name}));
            } break;

            case 'common': {
                this.companyId = props.params.companyId;

                if (props.params.users) this.existingUsers = props.params.users;

                gd.session.companyUsers.filterByCompanyAndRoles(props.params.companyId).map(cu=>{
                    if (!this.existingUsers.includes(cu.user.id)) {
                        if (!tempProjectUsersIds.includes(cu.user.id)) {
                            this.companyUsers.push(cu);
                        }
                    }
                });

                // sort by name
                this.projectUsers = [];
                this.companyUsers = _.sortBy(this.companyUsers,(cu=>cu.user.name));
            } break;

            case 'company-admin': {
                this.companyId = gd.companyId

                this.existingUsers = gd.session.companyUsers.findAdmins().map(companyUser=>{return companyUser.user.id; });

                gd.session.companyUsers.filterByCompanyAndRoles(gd.companyId, [gd.const.companyRole.MANAGER]).map(cu=>{
                    if (!this.existingUsers.includes(cu.user.id)) {
                        if (!tempProjectUsersIds.includes(cu.user.id)) {
                            this.companyUsers.push(cu);
                        }
                    }
                });

                // sort by name
                this.projectUsers = [];
                this.companyUsers = _.sortBy(this.companyUsers,(cu=>cu.user.name));
            } break;
        }

        this.state = {
            'search': '',
            'selected': []
        }
    }

    canSubmit = () => this.state.selected && this.state.selected.length > 0

    onUserClick = (userId, type, e) => {
        e.stopPropagation();

        if (this.multiselect) {
            const newSelected = this.state.selected.slice();
            const existingKey = _.findIndex(newSelected, obj => obj.userId === userId);

            if (existingKey !== -1) {
                newSelected.splice(existingKey,1);
            } else {
                newSelected.push({
                    userId: userId,
                    access: gd.ac.check.company.isFullAccess(userId) ? Access.FULL : Access.STANDARD,
                    type: type
                })
            }

            this.setState({
                selected: newSelected
            });
        } else {
            switch (this.mode) {
                case 'project':
                    const newSelected = [{
                        userId: userId,
                        access: gd.const.project.access.STANDARD,
                        type: type
                    }];

                    this.setState({
                        selected: newSelected
                    });
                    break;

                case 'task':
                    switch (type) {
                        case 'project':
                            this.props.params.onSubmit(userId, gd.const.project.access.STANDARD, type)
                            break

                        case 'company':
                            const newSelected = [{
                                userId  : userId,
                                access  : gd.const.project.access.STANDARD,
                                type    : type
                            }]

                            this.setState({
                                selected: newSelected
                            })
                            break
                    }

                    break
                case 'company-admin':
                case 'chat':
                case 'common': this.props.params.onSubmit(userId, gd.const.project.access.STANDARD, type); break;
            }
        }
    }

    onUserAdd = (userId, access, type, e) =>  {
        this.props.params.onSubmit(userId, access, type)
    }

    onSubmit(result) {
        if (this.multiselect) {
            this.props.params.onSubmit.call(this.props.params.this,this.state.selected);
        } else {
            switch (this.mode) {
                case 'project': this.props.params.onSubmit.call(this.props.params.this,this.state.selected[0]); break;
                case 'task':    this.props.params.onSubmit.call(this.props.params.this,result); break;
                case 'chat':
                case 'common': this.props.params.onSubmit.call(this.props.params.this,result); break;
            }
        }
    }

    onClickSubmit = (e) => {
        e.stopPropagation();
        this.onSubmit();
    }

    onSearchCancel = () => {
        this.setState({search: ''})
    }

    onSearchChange = (event) => {
        this.setState({search: event.target.value ? event.target.value : ''})
    }

    onAccessSelect = (userId, access) => {
        const selected = this.state.selected;

        selected.map(item=>{
            if (item.userId === userId) item.access = access;
        });

        this.setState({
            selected: selected
        });
    }

    render() {
        let ModalAddForm;
        switch (this.mode) {
            case 'chat':
            case 'task':    ModalAddForm = ModalAddUserTaskUsersForm; break;
            case 'project': ModalAddForm = ModalAddUserProjectUsersForm; break;
            case 'company-admin':
            case 'common':
                ModalAddForm = ModalAddUserCommonUsersForm;
            break;
        }

        return <ModalAddForm search             = {this.state.search}
                             projectUsers       = {this.projectUsers}
                             companyUsers       = {this.companyUsers}
                             projectId          = {this.projectId}
                             multiselect        = {this.multiselect}
                             mode               = {this.mode}
                             selected           = {this.state.selected}
                             showDepartments    = {this.showDepartments}
                             accessLevels       = {this.accessLevels}
                             canSubmit          = {this.canSubmit()}
                             onClickSubmit      = {this.onClickSubmit}
                             onUserClick        = {this.onUserClick}
                             onUserAdd          = {this.onUserAdd}
                             onAccessSelect     = {this.onAccessSelect}
                             onSearchChange     = {this.onSearchChange}
                             onSearchCancel     = {this.onSearchCancel}
                             closeModal         = {this.closeModal}/>
    }
}

module.exports = ModalAddUser;